import { request } from './http';

export async function getBugReports(query = '') {
    const suffix = query ? `?${query}` : '';
    return request(`/bug-reports${suffix}`);
  }

export async function getBugReport(id) {
    return request(`/bug-reports/${encodeURIComponent(id)}`);
  }

export async function createBugReport(payload) {
    return request('/bug-reports', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateBugReportStatus(id, payload) {
    return request(`/bug-reports/${encodeURIComponent(id)}/status`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function confirmBugReport(id, payload) {
    return request(`/bug-reports/${encodeURIComponent(id)}/confirm`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function archiveBugReport(id) {
    return request(`/bug-reports/${encodeURIComponent(id)}/archive`, {
      method: 'PUT',
      body: JSON.stringify({})
    });
  }

export async function restoreBugReport(id) {
    return request(`/bug-reports/${encodeURIComponent(id)}/restore`, {
      method: 'PUT',
      body: JSON.stringify({})
    });
  }

export const bugReportsApi = {
  getBugReports,
  getBugReport,
  createBugReport,
  updateBugReportStatus,
  confirmBugReport,
  archiveBugReport,
  restoreBugReport,
};

